import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from 'react-icons/fa'; // Assuming react-icons is available
import { FaXTwitter } from 'react-icons/fa6'; // Correct X icon
import { BrandName } from "../config/brand";

const Footer = () => {
  return (
    <footer
      className="footer mt-auto py-3 bg-white"
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 text-md-start text-center">
            <span className="mb-0">
              &copy; {new Date().getFullYear()} <strong><BrandName /></strong> All Rights Reserved.
            </span>
          </div>
          <div className="col-md-6 text-md-end text-center">
            <span className="me-2">Follow Us:</span>
            <a href="https://facebook.com" className="text-secondary me-2" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            {/* Using X icon if available, else Twitter fallback */}
            <a href="https://twitter.com" className="text-secondary me-2" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://linkedin.com" className="text-secondary me-2" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://youtube.com" className="text-secondary" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;